<template>
    <form method="post" class="text-base">
        <label class="block">
            <span class="text-brand-gray-700">First Name</span>
            <input class="appearance-none block w-full px-3 py-2 border rounded-full placeholder-brand-gray-500 focus:outline-none focus:ring-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                   type="text" name="firstName" v-model="form.firstName" required="required" />
        </label>
        <label class="block">
            <span class="text-brand-gray-700">Last Name</span>
            <input class="appearance-none block w-full px-3 py-2 border rounded-full placeholder-brand-gray-500 focus:outline-none focus:ring-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                   type="text" name="lastName" v-model="form.lastName" required="required" />
        </label>
        <label class="block">
            <span class="text-brand-gray-700">Email Address</span>
            <input class="appearance-none block w-full px-3 py-2 border rounded-full placeholder-brand-gray-500 focus:outline-none focus:ring-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                   type="email" name="emailAddress" v-model="form.emailAddress" required="required" />
        </label>
        <label class="block">
            <span class="text-brand-gray-700">Phone Number</span>
            <input class="appearance-none block w-full px-3 py-2 border rounded-full placeholder-brand-gray-500 focus:outline-none focus:ring-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                   type="tel" name="phone" v-model="form.phone" required="required" />
        </label>
        <div class="mt-4">
            <span class="text-brand-gray-700">Degree Type</span>
            <div class="mt-2">
                <label class="inline-flex items-center">
                    <input type="radio" class="form-radio" name="programType" v-model="form.programType" value="RN" required />
                    <span class="ml-2">RN</span>
                </label>
                <label class="inline-flex items-center">
                    <input type="radio" class="form-radio" name="programType" v-model="form.programType" value="PN" required />
                    <span class="ml-2">PN</span>
                </label>
            </div>
        </div>
        <label class="block">
            <span class="text-brand-gray-700">Graduation Date</span>
          <div class="mt-1 rounded-full shadow-sm">
            <div class="relative w-full">
            <v-date-picker
                    :input-props='{
                                id: "gradDate",
                                class: "appearance-none block w-full px-3 py-2 border border-brand-gray-500 rounded-full placeholder-brand-gray-500 focus:outline-none focus:ring-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5",
                                required: "required",
                                name: "graduationDate"
                            }'
                    is-dark
                    color="indigo"
                    v-model="graduationInput"></v-date-picker>
            </div>
          </div>
        </label>
        <label class="block mt-4">
            <span class="text-brand-gray-700">Your Nursing School State/Province</span>
            <select name="schoolState" class="text-brand-gray-500 appearance-none block w-full px-3 py-2 border border-brand-gray-500 rounded-full placeholder-brand-gray-500 focus:outline-none focus:ring-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    v-model="form.nursingSchoolState" @change="loadSchools">>
                <option value="">State/Province of Nursing School</option>
                <option v-for="province in provinces" :value="province.abbreviation">
                    {{ province.name }}
                </option>
            </select>
        </label>
        <label class="block mt-4">
            <span class="text-brand-gray-700">Name of Nursing School</span>
            <select name="nursingSchoolId" v-model="form.nursingSchoolId" class="text-brand-gray-500 appearance-none block w-full px-3 py-2 border border-brand-gray-500 rounded-full placeholder-brand-gray-500 focus:outline-none focus:ring-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5">
                <option value="" class="text-brand-gray-600" v-if="schools.length > 0">Your Nursing School:</option>
                <option value="" class="text-brand-gray-600" v-else disabled>Select Your School's State</option>
                <option v-for="school in schools" :key="school.schoolId" :value="school.schoolId">{{school.schoolName}}</option>
            </select>
        </label>
        <div class="mt-4">
            <button type="submit" class="btn btn-orange mb-3 w-full font-bold focus:outline-none focus:ring py-4">Register</button>
        </div>
    </form>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
        name: "LeadForm",

        props: {
            provinces: {
                required: true,
                type: Array
            }
        },

        data() {
            return {
                form: {
                    emailAddress: '',
                    firstName: '',
                    lastName: '',
                    graduationDate: '',
                    nursingSchoolId: '',
                    nursingSchoolState: '',
                    phone: '',
                    programType: '',
                    schoolState: ''
                },
                graduationInput: '',
                schools: []
            }
        },

        watch: {
            graduationInput: function(newDate, oldDate) {
                this.form.graduationDate = moment(newDate).format('YYYY-MM-DD');
            }
        },

        methods: {
            async loadSchools() {
                try{
                    const { data } = await axios.get(`/ajax/schoolByState/${this.form.nursingSchoolState}`);
                    this.schools = data;
                }catch(e) {

                }
            },
        }
    }
</script>

<style scoped>

</style>